export default "/storefront/client/images/safari.png";